import PropTypes from 'prop-types'

export const AdasImage = ({
  src,
  alt = '',
  className,
  style,
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  color,
  ...props
}) => <img src={src} alt={alt} className={className} style={style} {...props} />

AdasImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}
